// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"b36d437190b448ae92c5","339":"b3970bebcf9c117d3dbf"}[chunkId] + ".js";
};